import i18n from '@/plugins/i18n/index'

export const PaymentType = [i18n.global.t('accounts.search.freight'), i18n.global.t('accounts.search.pod'), i18n.global.t('accounts.search.pr')]

export const exportOptions = [
  { title: i18n.global.t('accounts.search.excel'), value: 'excel' },
  { title: i18n.global.t('accounts.search.pdf'), value: 'pdf' },
]

export const capacityType = [i18n.global.t('accounts.search.tons')]

export const mcBookType = [i18n.global.t('accounts.search.yashwantrao')]

// Define Type
export const accountTypes = {
  truckerPayable: 'truckerPayable',
  loaderPayable: 'loaderPayable',
  commonData: 'commonData',
  mcBook: 'mcBook',
  cashLedger: 'cashLedger',
}

export const customDaysTypes = [
  { value: 'today', title: 'Today' },
  { value: 'last30', title: 'Last 30 Days' },
  { value: 'last90', title: 'Last 90 Days' },
  { value: 'last180', title: 'Last 180 Days' },
  { value: 'custom', title: 'Custom' },
]

/*
 * The all-transactions report's period filter, which doubles as the way to reach entries
 * still waiting for an owner. They are a backlog rather than a period, so the option
 * carries no date range of its own and pins the Assigned filter instead.
 */
export const transactionsDaysTypes = [
  customDaysTypes[0],
  { value: 'unassigned', title: 'Unassigned' },
  ...customDaysTypes.slice(1),
]

export const ledgerDaysTypes = [
  { value: 'all', title: 'All' },
  ...customDaysTypes,
]

export const centralizedTableOptions = reactive({
  page: 1,
  limit: 10,
  sortField: '',
  sortOrder: '',
  search: false,
})

export const centralizedPaginationPage = [
  { value: 10, title: '10' },
  { value: 25, title: '25' },
  { value: 50, title: '50' },
  { value: 100, title: '100' },
]

// Transaction Report
export const transactionHeader = [
  { title: 'ID', key: 'formattedId' },
  { title: 'Transaction Date', key: 'date' },
  { title: 'CNF ID', key: 'confirmationId' },
  { title: 'User Type', key: 'userType' },
  { title: 'Business Name', key: 'businessName' },
  { title: 'Description', key: 'description' },
  { title: 'Amount Type', key: 'amountType' },
  { title: 'Tran. Type', key: 'paymentMethod' },
  { title: 'Remarks', key: 'reference' },
  { title: 'Receivable', key: 'receivable' },
  { title: 'Received', key: 'received' },
  { title: 'Payable', key: 'payable' },
  { title: 'Paid', key: 'paid' },
  { title: 'Discount', key: 'discount' },
]

// The transactions report shares the columns above and must not grow an Actions column,
// so the party-to-party report keeps its own header rather than widening that one.
export const partyToPartyTransactionHeader = [
  ...transactionHeader,
  { title: 'Actions', key: 'actions', sortable: false },
]

// Same reasoning: the all-transactions report needs actions for its unassigned rows,
// while `transactionHeader` stays shared with the surfaces that must not show them.
export const transactionsReportHeader = [
  ...transactionHeader,
  { title: 'Actions', key: 'actions', sortable: false },
]

// The account reports, as their route meta declares them: the all-transactions report is
// the one page an entry with no owner is listed on, and the party-to-party report the one
// page a transfer added from outside a confirmation is listed on. Both routes are guarded
// by the same ability.
export const accountsRoutes = {
  transactionsReport: 'accounts-transactions-ledger-report',
  partyToPartyReport: 'accounts-party-to-party-transactions-report',
  transactionsReportAction: 'manage',
  transactionsReportSubject: 'Accounts',
}

export const assignedStatusOptions = [
  { text: 'Assigned', value: 'assigned' },
  { text: 'Unassigned', value: 'unassigned' },
]

// Trucker  Ledger Report
export const truckerHeader = [
  { title: 'ID', key: 'id' },
  { title: 'Business Name', key: 'companyName' },
  { title: 'Trading Name', key: 'tradingName' },
  { title: 'Receivable (A)', key: 'receivable' },
  { title: 'Received (B)', key: 'received' },
  { title: 'Payable (C)', key: 'payable' },
  { title: 'Paid (D)', key: 'paid' },
  { title: 'Discount(E)', key: 'totalDiscount' },
  { title: 'Balance (A-B-C+D+E)', key: 'balance' },
  { title: 'Actions', key: 'actions', sortable: false },
]

// Loader Ledger Report
export const loaderHeader = [
  { title: 'ID', key: 'id' },
  { title: 'Business Name', key: 'companyName' },
  { title: 'Trading Name', key: 'tradingName' },
  { title: 'Receivable (A)', key: 'receivable' },
  { title: 'Received (B)', key: 'received' },
  { title: 'Payable (C)', key: 'payable' },
  { title: 'Paid (D)', key: 'paid' },
  { title: 'Discount(E)', key: 'totalDiscount' },
  { title: 'Balance (A-B-C+D+E)', key: 'balance' },
  { title: 'Actions', key: 'actions', sortable: false },
]

// MC Book Data
export const mcBookHeader = [
  { title: 'ID', key: 'id' },
  { title: 'MC Book Name', key: 'mcBookName' },
  { title: 'Associated With', key: 'associatedWith' },
  { title: 'Business Name', key: 'businessName' },
  { title: 'Primary Mobile No.', key: 'mobile' },
  { title: 'Receivable (A)', key: 'receivable' },
  { title: 'Received (B)', key: 'received' },
  { title: 'Payable (C)', key: 'payable' },
  { title: 'Paid (D)', key: 'paid' },
  { title: 'Discount(E)', key: 'totalDiscount' },
  { title: 'Balance (A-B-C+D+E)', key: 'balance' },
  { title: 'Actions', key: 'actions', sortable: false },
]

export const cashLedgerHeader = [
  { title: 'ID', key: 'formattedId', sortable: false },
  { title: 'User Type', key: 'userType', sortable: false },
  { title: 'User ID', key: 'userId', sortable: false },
  { title: 'Business Name', key: 'businessName', sortable: false },
  { title: 'Transaction Date', key: 'date' },
  { title: 'CNF ID', key: 'confirmationId' },
  { title: 'Description', key: 'description' },
  { title: 'Remarks', key: 'reference' },
  { title: 'Received', key: 'received' },
  { title: 'Paid', key: 'paid' },
  { title: 'Discount', key: 'discount' },
]

export const bankHeader = [
  { title: 'ID', key: 'formattedId', sortable: false },
  { title: 'User Type', key: 'userType', sortable: false },
  { title: 'User ID', key: 'userId', sortable: false },
  { title: 'Business Name', key: 'businessName', sortable: false },
  { title: 'Transaction Date', key: 'date' },
  { title: 'CNF ID', key: 'confirmationId' },
  { title: 'Description', key: 'description' },
  { title: 'Remarks', key: 'reference' },
  { title: 'Received', key: 'received' },
  { title: 'Paid', key: 'paid' },
  { title: 'Discount', key: 'discount' },
]

export const balanceHeader = [
  { title: 'Receivable', value: 'receivable' },
]

export const balanceData = [
  { receivable: '746' },
]

export const commissionReportHeader = [
  { title: 'GST IN', key: 'truckerGst' },
  { title: 'Trucker Business Name', key: 'truckerBusinessName' },
  { title: 'Trucker ID / Balance', key: 'truckerIdBalance' },
  { title: 'Primary Name', key: 'truckerPrimaryName' },
  { title: 'Place of Supply', key: 'placeOfSupply' },
  { title: 'Invoice No. (Or CNF ID)', key: 'invoiceNo' },
  { title: 'Mobile No.', key: 'truckerMobile' },
  { title: 'Truck No./Tyres', key: 'truckNo' },
  { title: 'Invoice Date | Loading Date', key: 'invoiceDate' },
  { title: 'Loading Points', key: 'loadingPoint' },
  { title: 'Capacity / Freight Method', key: 'capacityList' },
  { title: 'Invoice Value', key: 'invoiceValue' },
  { title: 'Unloading Points', key: 'unloadingPoint' },
  { title: 'FR + PR + OR + Misc.', key: 'frPrOrMisc' },
  { title: 'Status', key: 'status' },
]

export const commissionReportTableOptions = reactive({
  page: 1,
  limit: 10,
  sortField: null,
  sortOrder: null,
  search: false,
})
